export enum MenuNames {
  INDEX = 'index',
  COURSES = 'cursos',
  COURSE_DETAIL = 'detalhe-curso',
  TEAM = 'equipe',
  CONTACT = 'contato',
}
